import { useState } from "react";
import { Edit, Remove, Success } from "../../../assets/icons";
import { createNewCaseButtonOptions, designTypeButtonOptions, duplicateCaseButtonOptions, viewButtonOptions } from "../../../constants/columns/projectdetails/buttonGroup";
import { ProjectStatus } from "../../../utilities/AppConstants";
import ButtonGroup from "../../common/button-group";
import Tooltip from "../../common/tooltip-1";
import CaseDialog from "../../projectheader/CaseDialog";
import ConfirmationDialog from "../../common/confirmation-dialog";
import { useAppSelector } from "../../../store/hooks/StoreHooks";

interface CaseCardsProps {
    isOpen?: boolean;
    parentProjectID?: string;
    activeCase?: any;
    setActiveCase?: any;
    projectAndAffiliations?: any[];
    filteredAffiliations?: any[];
    handleCaseDuplicate?: (caseItem: any, index: number) => Promise<void>;
    handleCaseView?: (caseItem: any, index: number) => void;
    handleCaseDialogCreate?: (payload?: any) => void;
    handleCaseDialogUpdate?: (payload?: any) => void;
    activeActionItem?: number;
    setActiveActionItem?: (index: number) => void;
    onRemoveConfirmationClose?: () => void;
};

const CaseCards: React.FC<CaseCardsProps> = ({
    isOpen,
    parentProjectID,
    activeCase,
    setActiveCase,
    projectAndAffiliations = [],
    filteredAffiliations,
    handleCaseDuplicate,
    handleCaseView,
    handleCaseDialogCreate,
    handleCaseDialogUpdate,
    activeActionItem = 0,
    setActiveActionItem,
    onRemoveConfirmationClose,
}) => {
    const { customerEnabled, customerCreated, user } = useAppSelector((state) => state?.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
    const { sharedCases } = useAppSelector((state) => state?.myProjects);
    const [showCaseDialog, setShowCaseDialog] = useState<boolean>(false);
    const [caseModalMode, setCaseModalMode] = useState<"create" | "update">("create");
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const onCaseDialogClose = (payload?: any) => {
        if (payload) {
            if (caseModalMode === "update" && handleCaseDialogUpdate) {
                handleCaseDialogUpdate({ ...payload, caseModalMode });
            } else {
                handleCaseDialogCreate && handleCaseDialogCreate({ ...payload, caseModalMode });
            }
        }
        setShowCaseDialog(false);
    };

    const onConfirmationClose = (yes: boolean) => {
        setShowConfirmationDialog(false);
        if (yes && onRemoveConfirmationClose) {
            onRemoveConfirmationClose();
            setShowConfirmationDialog(false);
        }
    };

    return (
        <>
            {isOpen && (
                <div className='w-full border-[1px] bg-darkcolor-800 border-darkcolor-400 rounded-b-[8px] p-4'>
                    <div className='flex flex-wrap gap-8 text-neutral-25'>
                        {filteredAffiliations?.map((x: any, index: number) => {
                            return (
                                <div className={`
                                        p-4 
                                        rounded-[8px] 
                                        bg-darkcolor-700 
                                        border 
                                        w-[340px] 
                                        ${activeCase?.index === index
                                        ? 'border-2 border-primary-600'
                                        : 'border border-darkcolor-400'
                                    }
                                    `}>
                                    <div className='flex justify-between w-full mb-0'>
                                        {activeCase?.index === index && (
                                            <div className='bg-primary-600 w-1 rounded-[4px] mr-2 mb-3 mt-1'></div>
                                        )}
                                        <div className='flex size-12 flex-1'>
                                            <div className='flex flex-1 gap-[8px] text-[14px] font-normal mb-1 grow-5 size-8'>
                                                {x?.displayCaseName}:
                                                <div>
                                                    <span className='border border-color-[#E8E3EF] rounded px-2 py-[2px] text-color-[#FCFCFD] text-[12px] font-semibold'>
                                                        {x?.liftType === 1 ? "ESP" : "Jet lift"}
                                                    </span>
                                                </div>
                                            </div>
                                            {((!customerEnabled &&
                                                !projectReadOnly &&
                                                x.status !== ProjectStatus.acknowldged) ||
                                                (customerEnabled &&
                                                    customerCreated &&
                                                    x.created_By === user?.userID &&
                                                    projectAndAffiliations?.every((item: any) => item?.status !== ProjectStatus?.acknowldged))) && (
                                                    <div className='flex-2 gap-4 flex grow-5'>
                                                        <a
                                                            flex-1
                                                            href='javascript:void(0)'
                                                            onClick={() => {
                                                                setShowCaseDialog(true);
                                                                setCaseModalMode("update");
                                                                setActiveActionItem && setActiveActionItem(projectAndAffiliations?.findIndex((item: any) => item?.projectID === x.projectID));
                                                            }}
                                                        >
                                                            <Edit />
                                                        </a>
                                                        <Tooltip
                                                            content={
                                                                sharedCases?.length > 0 &&
                                                                sharedCases[0]?.case?.includes(
                                                                    x.projectID
                                                                ) &&
                                                                parentProjectID !== x.projectID &&
                                                                "Unshare the case to delete"
                                                            }
                                                        >
                                                            <a
                                                                flex-2
                                                                href='javascript:void(0)'
                                                                className={
                                                                    parentProjectID === x.projectID ||
                                                                        (sharedCases?.length &&
                                                                            sharedCases[0]?.case?.includes(
                                                                                x.projectID
                                                                            )) || projectAndAffiliations?.find((item: any) => item?.copyFrom === x.projectID)
                                                                        ? "opacity-5 cursor-not-allowed pointer-events-none"
                                                                        : ""
                                                                }
                                                                onClick={() => {
                                                                    setShowConfirmationDialog(true);
                                                                    setActiveActionItem && setActiveActionItem(projectAndAffiliations?.findIndex((item: any) => item?.projectID === x.projectID));
                                                                }}
                                                            >
                                                                <Remove />
                                                            </a>
                                                        </Tooltip>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                    <div className='text-[18px] font-normal mb-2 min-h-[24px] break-words'>
                                        {" "}
                                        {x?.caseName}
                                    </div>

                                    <div className=' text-[14px] font-normal mb-2 min-h-[24px] break-words'>
                                        {x?.caseDescription}
                                    </div>
                                    <div className='flex items-center gap-[10px] mb-4'>
                                        <div className="text-[10px] font-normal">Created by: {x?.createdByName}</div>
                                        <div className="flex items-center text-[10px] font-normal gap-[10px]">
                                            {
                                                (sharedCases?.length > 0 &&
                                                    sharedCases[0]?.case?.includes(x.projectID) &&
                                                    x.status !== ProjectStatus.acknowldged) ? (
                                                    <>
                                                        <div className="text-neutral-100 ml-2">|</div>
                                                        <span className='border border-warning-400 rounded px-1 py-0 text-warning-400'>
                                                            Shared
                                                        </span>
                                                    </>
                                                ) : (
                                                    x?.userRole?.toLowerCase()?.includes('customer') && (
                                                        <>
                                                            <div className="text-neutral-100 ml-2">|</div>
                                                            <span className='border border-warning-400 rounded px-1 py-0 text-warning-400'>
                                                                Customer
                                                            </span>
                                                        </>
                                                    )
                                                )}

                                            {x.status === ProjectStatus.acknowldged && (
                                                <>
                                                    <div className="text-neutral-100 ml-2">|</div>
                                                    <span className='flex items-center border border-[#48bb78] rounded px-1 py-0 text-[#48bb78]'>
                                                        <Success color='#48bb78' size={16} />
                                                        &nbsp;Acknowledged
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='border-b-[1px] border-darkcolor-400 mb-4'></div>
                                    <div className='flex justify-between gap-4'>
                                        {
                                            (!projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.acknowldged) &&
                                                ((!projectReadOnly && ![ProjectStatus?.acknowldged, ProjectStatus?.needReview, ProjectStatus?.reviewInProgress]?.includes(x?.status) && !customerEnabled) ||
                                                    (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(x.projectID) && (sharedCases[0]?.email || "").trim().toLowerCase() === (user?.email || "").trim().toLowerCase()
                                                    )))
                                            &&
                                            (
                                                <ButtonGroup
                                                    buttonOptions={duplicateCaseButtonOptions}
                                                    handleClick={(option: any) => {
                                                        if (option?.label === "Duplicate case" && handleCaseDuplicate) {
                                                            handleCaseDuplicate(x, index)
                                                        }
                                                        return;
                                                    }}
                                                    className='w-2/4'
                                                />
                                            )}
                                        <ButtonGroup
                                            buttonOptions={viewButtonOptions}
                                            handleClick={(option: any) => {
                                                if (option?.label === "View" && handleCaseView) {
                                                    handleCaseView(x, index)
                                                }
                                                return;
                                            }}
                                            className='w-2/4'
                                        />
                                    </div>
                                </div>
                            );
                        })}
                        {!customerEnabled &&
                            !projectReadOnly &&
                            projectAndAffiliations && projectAndAffiliations?.filter(
                                (item: any) => item?.status === ProjectStatus.inProgress
                            )?.length > 0 && (
                                <div className='flex flex-col p-4 rounded-[8px] bg-darkcolor-700 border-darkcolor-400 w-[340px] items-center justify-center min-h-[244px]'>
                                    <div className='flex justify-center w-full mb-4'>
                                        <div className='text-[16px]  mb-1'>
                                            {" "}
                                            Create new case
                                        </div>
                                    </div>
                                    <div className='text-center text-[14px] font-normal mb-4'>
                                        Initiate a new sizing configuration for selected well
                                    </div>
                                    <div className='flex justify-between gap-4'>
                                        <ButtonGroup
                                            buttonOptions={createNewCaseButtonOptions}
                                            handleClick={() => {
                                                setShowCaseDialog(true);
                                                setCaseModalMode("create");
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            )}
            <CaseDialog
                show={showCaseDialog}
                mode={caseModalMode}
                caseDetails={
                    projectAndAffiliations?.length > 0 &&
                    projectAndAffiliations?.[activeActionItem]
                }
                close={onCaseDialogClose}
                showDesignType={true}
                designButtonOptions={designTypeButtonOptions.map((option: any) => ({
                    ...option,
                    disabled: caseModalMode === "create" ? false : projectAndAffiliations?.[activeActionItem]?.liftType !== option?.id,
                }))}
            />
            <ConfirmationDialog
                confirmMsg='Are you sure you wish to remove this case from your list?'
                close={onConfirmationClose}
                show={showConfirmationDialog}
            />
        </>
    );
};

export default CaseCards;